import React, { useEffect, useState } from 'react';
import '../../styles/alert.css';

const Alert = ({
  type = 'info',
  message,
  description,
  closable = false,
  showIcon = true,
  onClose,
  duration = 0,
  className = ''
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration]);

  const handleClose = () => {
    setVisible(false);
    if (onClose) onClose();
  };

  if (!visible) return null;

  const icons = {
    success: '✅',
    error: '❌',
    warning: '⚠️',
    info: 'ℹ️'
  };

  return (
    <div className={`alert alert-${type} ${className}`} role="alert">
      {showIcon && <div className="alert-icon">{icons[type]}</div>}
      
      <div className="alert-content">
        {message && <div className="alert-message">{message}</div>}
        {description && <div className="alert-description">{description}</div>}
      </div>
      
      {closable && (
        <button className="alert-close" onClick={handleClose}>
          ×
        </button>
      )}
    </div>
  );
};

export default Alert;
